import { useAccountSummaryV2Query } from '@syf-api-library/account-summary';
import useConfig from '../context/config.context';
import useTypesafeAnswer from './useTypesafeAnswer';
const useAccountSummary = () => {
    const { config, accountId } = useConfig();
    const { data, isSuccess, isError, isLoading } = useAccountSummaryV2Query({
        config,
        keyProps: { accountId, accountIdType: 'guid' }
    });
    const { currentAnswer: currentReason } = useTypesafeAnswer('ReasonSelection');
    const isSemu = data === null || data === void 0 ? void 0 : data.accountInfo.multiplePresentationInstruments;
    const accountName = data === null || data === void 0 ? void 0 : data.product.displayName;
    return {
        accountName,
        currentReason,
        isSemu,
        isSuccess,
        isError,
        isLoading
    };
};
export default useAccountSummary;
//# sourceMappingURL=useAccountSummary.js.map